import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Heading, Table, TableColumnConfig, Tabs } from '@frontend/design-system';
import { TableData } from '../../utils/typings';

interface TableTabsSwitcherProps {
  heading: string;
  rowCount: number;
  tableColumns: TableColumnConfig<TableData>[];
  tabHeaders: { id: string; label: string }[];
  tabContent: { id: string; tableInstanceId: string; tableData: TableData[] }[];
}

const TableTabsSwitcher = ({ heading, rowCount, tableColumns, tabHeaders, tabContent }: TableTabsSwitcherProps) => {
  return (
    <>
      <Heading level={3} css={headingStyle}>
        {heading} ({rowCount})
      </Heading>
      <Tabs initialTab={tabHeaders[0]?.id}>
        {tabHeaders && (
          <Tabs.Bar>
            {tabHeaders.map((tab) => (
              <Tabs.Tab key={tab.id} id={tab.id}>
                {tab.label}
              </Tabs.Tab>
            ))}
          </Tabs.Bar>
        )}
        {tabContent &&
          tabContent.map((tab) => (
            <Tabs.Panel key={tab.id} controller={tab.id} css={tabContainerStyle}>
              <Table
                tableInstanceId={tab.tableInstanceId}
                fullHeight
                isFocusable={false}
                data={tab.tableData}
                colConfig={tableColumns}
              />
            </Tabs.Panel>
          ))}
      </Tabs>
    </>
  );
};

export default TableTabsSwitcher;

const headingStyle = css`
  margin-bottom: ${theme.spacing(1)};
`;

const tabContainerStyle = css`
  padding-top: ${theme.spacing(2)};
`;
